import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { CtaBand } from "@/components/site/CtaBand";
import { AREAS, REGIONS } from "@/data/areas";

export default function Areas() {
  return (
    <>
      <Seo title="Plumber Service Areas Sydney | Austyle Plumbing" description="Austyle Plumbing services St George, the Sutherland Shire, Canterbury-Bankstown, the Inner West, Eastern Suburbs, North Shore, Western Sydney and Macarthur." />
      <PageHero testid="areas-hero" eyebrow="Service areas" lines={["Plumbing for", "greater Sydney."]} image="/images/ig/p10_2.jpg"
        intro={`${AREAS.length}+ suburbs across eight regions — from the Sutherland Shire to the Northern Beaches, the City to Macarthur.`} />
      <section className="bg-porcelain py-20 sm:py-28">
        <div className="container-x space-y-16">
          {Object.entries(REGIONS).map(([key, r]) => (
            <div key={key} data-testid={`region-${key}`} className="grid gap-8 lg:grid-cols-12 border-t border-ink/15 pt-10">
              <Reveal className="lg:col-span-4">
                <h2 className="font-wide font-black uppercase text-3xl sm:text-4xl tracking-tight">{r.name}</h2>
                <p className="mt-4 text-slate-600 text-sm leading-relaxed">{r.blurb}</p>
              </Reveal>
              <Reveal className="lg:col-span-8 grid gap-2 sm:grid-cols-2 md:grid-cols-3 content-start" delay={0.1}>
                {AREAS.filter((a) => a.region === key).map((a) => (
                  <Link key={a.slug} to={`/areas/${a.slug}`} data-testid={`area-link-${a.slug}`}
                    className="group flex items-center justify-between h-14 px-5 bg-white border border-ink/10 hover:border-ink hover:bg-ink hover:text-white transition-colors">
                    <span className="font-bold">{a.name} <span className="font-mono text-xs opacity-60 ml-1">{a.postcode}</span></span>
                    <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
                  </Link>
                ))}
              </Reveal>
            </div>
          ))}
          <p className="text-sm text-slate-600">Don't see your suburb? We cover most of Sydney — <Link to="/contact" data-testid="areas-contact-link" className="font-bold text-cobalt underline">get in touch</Link>.</p>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
